export const firebase = {
    apiKey: 'AIzaSyAPwHkfyHKrgn4Lvh28Cl9FXMusqPHBsVA',
    authDomain: 'personalwebpage-ee90e.firebaseapp.com',
    databaseURL: 'https://personalwebpage-ee90e.firebaseio.com',
    projectId: 'personalwebpage-ee90e',
    storageBucket: 'personalwebpage-ee90e.appspot.com',
    messagingSenderId: '873627194608',
};
